// extracted by mini-css-extract-plugin
export default {"logo-container":"Logo_logo-container__W7L-g","logo-img":"Logo_logo-img__L5tn8"};